declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
    dataLayer: Record<string, unknown>[];
  }
}

export const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;
export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

/**
 * Push an arbitrary event payload into window.dataLayer.
 * Safe to call on the server (no-ops) or before GTM loads —
 * GTM will replay the dataLayer once it initialises.
 */
export function pushDataLayer(payload: Record<string, unknown>) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}

/**
 * Track a pageview. When a GTM container is configured, we push a
 * `pageview` event to the dataLayer (GTM handles the GA4 tag). When
 * only a raw GA4 measurement ID is configured we fall back to calling
 * gtag('config') directly.
 */
export function pageview(url: string) {
  if (typeof window === "undefined") return;

  if (GTM_ID) {
    pushDataLayer({ event: "pageview", page_path: url });
    return;
  }

  if (window.gtag && GA_MEASUREMENT_ID) {
    window.gtag("config", GA_MEASUREMENT_ID, { page_path: url });
  }
}

export function event(action: string, params: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;

  if (GTM_ID) {
    pushDataLayer({ event: action, ...params });
    return;
  }

  if (window.gtag) {
    window.gtag("event", action, params);
  }
}
